
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsVatRefundDtDialog extends Serenity.Extensions.GridEditorDialog<PsVatRefundDtRow> {
        protected getFormKey() { return PsVatRefundDtForm.formKey; }
        // protected getIdProperty() { return PsVatRefundDtRow.idProperty; }
        protected getLocalTextPrefix() { return PsVatRefundDtRow.localTextPrefix; }
        protected getNameProperty() { return PsVatRefundDtRow.nameProperty; }
        // protected getService() { return PsVatRefundDtService.baseUrl; }
        // protected getDeletePermission() { return PsVatRefundDtRow.deletePermission; }
        // protected getInsertPermission() { return PsVatRefundDtRow.insertPermission; }
        // protected getUpdatePermission() { return PsVatRefundDtRow.updatePermission; }

        protected form = new PsVatRefundDtForm(this.idPrefix);

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 0);
           

            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }
    }
}